/* eslint-disable */
export default {
  createCallLog: 'Criar log de chamadas',
  viewInSalesforce: 'Exibir no Salesforce',
  createLog: 'Criar log',
} as const;

// @key: @#@"createCallLog"@#@ @source: @#@"Create call log"@#@
// @key: @#@"viewInSalesforce"@#@ @source: @#@"View in Salesforce"@#@
// @key: @#@"createLog"@#@ @source: @#@"Create log"@#@
